import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { memberPortal } from "../member-portal";
require('parsley');
require('datatables.net');
require('datatablesResponsive');
require('parsley');
import { memberAddTraveller } from "../members/gov-travelstimulus";
import { bookingFormCommon } from "../c005-bookingform-common";

export class membertraveller {
	private editForm:any = $('#member-profile-edit');
	private travellmemberBase:any = new memberAddTraveller();
	private bookingformcommon = new bookingFormCommon();
	$scope: any = $('#member-profile-edit');
	addmy_showtrar:any;
	private memberBase:any = new memberPortal() ;$error:Array<any>;

	/**
	 * initialize all form inputs with focus and filled effects
	 * @return {any} [description]
	 */
	initTextInputs():any {
		let _self = this;
		
		let inputElArr:any = _self.editForm.find('input[type="text"], input[type="email"], textarea,input[type="checkbox"]');
		_self.memberBase.initFormTextInputs(inputElArr);
	}

    initDatepickerInputs(): any {
		let _self = this;
		let inputDateArr   = $('#edit-profile--date-of-birthupdate-traveller');
		let inputExpiryArr   = $('#edit-profile--passport-expiry-dateupdate-traveller');
		//let inputElArr:any = $.makeArray(inputDateArr,inputExpiryArr);
		
		let minDate = new Date((new Date().getFullYear() - 100).toString());
		let maxDate = new Date((new Date().getTime() - 1000*60*60*24*365*2));
		let expiryminDate = 0;
		let $updateProfileFlag:any = $('#updateProfileFlag').val();
		

		_self.memberBase.initDatepickerInputs(inputDateArr, minDate, maxDate);
		_self.memberBase.initDatepickerInputs(inputExpiryArr, expiryminDate, );
		
	}

	validateForm(form:any,addmyTravellerview:any): any {
		let isvalid:any=false;
		let _self = this;
		 {
      //alphanumeric validation
	 	
		let _window:any   = window;
		let formData:Array<any> = [];
		
		let validation:any = form.parsley({
			errorClass: 'has-error',
			excluded: ":hidden",
	        classHandler: function (el:any) {
	            return el.$element.closest('.form-item');
	        },
		});
		let icnumber_val:any  = form.find('input[name="NRIC--number"]').val();
		let dob_val:any  = form.find('input[name="date-of-birth"]').val();
		//alert("icnumber_val>>"+icnumber_val);
		//alert("dob_val>>"+dob_val);
		let ICvalidation:any;
		let date_of_birth: any;
		if(icnumber_val!='' && dob_val!='' && icnumber_val!==undefined){
			//alert("if.");
			let myDate = new Date(dob_val);
		let date = myDate.getDate();
		let dd:any;
		let icNum_val:any;
		if(date<10){
			dd='0'+date;
		}else{
			dd = date;
		}
		let month =  myDate.getMonth();
		month += 1;  // JavaScript months are 0-11
		let mm:any;
		if(month<10)
		{
			mm='0'+month;
		}else{
			mm=month;
		}

		let year = myDate.getFullYear()+'';
		let yy=year.substring(year.length-2);
		let dobval=yy+mm+dd;
		date_of_birth = dd + "/" + mm + "/" + year;
		icNum_val=icnumber_val.substring(0, 6);
		if(icnumber_val.length==12){
			if(icNum_val==dobval){
				//alert("true");
				//$('.nric--IC--number--error').hide();
				$('.nric--IC--number--error').addClass("hideClass");
				$('.nric--IC--number--error').removeClass("showClass");
				//$('.error_msg').addClass("showClass");
				ICvalidation=true;
			}else{
				//alert("false");
				//$('.nric--IC--number--error').show();
				$('.nric--IC--number--error').addClass("showClass");
				$('.nric--IC--number--error').removeClass("hideClass");
				//$('.error_msg').addClass("hideClass");
				//form.find('input[name="NRIC--number"]').val('');
				ICvalidation=false;
			}
		}else{
			$('.nric--IC--number--error').addClass("showClass");
			$('.nric--IC--number--error').removeClass("hideClass");
			//$('.error_msg').addClass("hideClass");
			ICvalidation=false;
		}
		
		}
		

		let validationResult:any = validation.validate();
		
			if ((validationResult&&ICvalidation)) {
				isvalid=true;
				formData = form.find('input:not([id*="-selectized"]), select, textarea, hidden').serializeArray();
				let fileInputs:any = form.find('input[type="file"]');
				if (fileInputs.length) {
					fileInputs.each(function(){
						let fileEl:any = $(this);
						formData.push({
							"name": fileEl[0].getAttribute('name'),
							"value": fileEl[0].files
						});
					});
				}
				
				let htmlFormData:any = new FormData(validation.$element[0]);
				formData.push({
					"date_of_birth": date_of_birth
				});
				htmlFormData.append("date_of_birth", date_of_birth);
				_self.updateMemberIc(htmlFormData,addmyTravellerview);				
			}
			
	        form.on('click', 'a[class^="focus-"]', function(){
	        	// take the field's name from the class
				let nameVal:string         = $(this).attr('class').replace(/focus-/g,'');
				let mabHeaderHeight:number = $('#mab-header').outerHeight();
				let errorField:any         = form.find("#" + nameVal);
				let errorFieldPos:number   = 0;
          function isSelectize(el:any) {
        	if (el.prop('type') == 'select-one' && el.hasClass('selectized')) {
        		return true;
        	} else {
        		return false;
        	}
		}
	        	if (isSelectize(errorField)) {
	        		// is selectize element
	        		errorFieldPos = errorField.next().offset().top - mabHeaderHeight - $(window).scrollTop() - errorField.next().outerHeight();
	        	} else {
	        		// every other input field
		        	errorFieldPos = errorField.offset().top - mabHeaderHeight - $(window).scrollTop();
	        	}

	        	// scroll to error element
	        	$("html, body").animate({ scrollTop: errorFieldPos });

	        	// focus on the element after scrolling to it
	        	// - if selectize, click on input field to trigger dropdown open
	        	if (isSelectize(errorField)) {
		        	errorField.next().find('.selectize-input').click();
	        	} else {
		        	errorField.focus();
	        	}
	        });

			if (!document.body.getAttribute('data-form-validate-init')) {
	        	document.body.setAttribute('data-form-validate-init', '1');
				// Before each validation, clear the error-validation of the div
		        _window.Parsley.on('form:validate', function(_form:any) {

		        	// get scoped validation summary div
		        	// scoped for pages with multiple forms
					let validationSummary:any = _form.$element.find('.error-validation');

		            validationSummary.html('');
		            validationSummary.hide();
		        });
			}

			if (!document.body.getAttribute('data-field-error-init')) {
	        	document.body.setAttribute('data-field-error-init', '1');
		        // When a field has an error
		        _window.Parsley.on('field:error', function(fieldInstance:any){

		        	// get scoped validation summary div
		        	// scoped for pages with multiple forms
					let validationSummary:any = fieldInstance.parent.$element.find('.error-validation');

		            // Get the error messages
		            // var messages = _window.ParsleyUI.getErrorsMessages(fieldInstance);
		            var messages = fieldInstance.getErrorsMessages();

		            // Get the field's name
		            var fieldId = fieldInstance.$element.attr('id');
					var fieldNameRaw = fieldInstance.$element.attr('name');
					var fieldName    = fieldNameRaw.replace(/--/g, ' ');
					fieldName        = fieldName.replace(/-/g, ' ');

		            // Loop through all the messages
				if(fieldName!='upload file name')
		{
		            for (var i in messages) {
		                var $m = $('<p id="error--'+fieldId+'"><a class="focus-' + fieldId + '" href="#">' + '<span class="field-name">' + fieldName + ': </span>' + messages[i] + '</a><p>');

		                let fieldIdExists:any = validationSummary.find('#error--'+fieldId);

		                // Append the errors to the div if not shown
		                if (fieldIdExists.length) {
		                	fieldIdExists.remove();
			                validationSummary.append($m);
		                } else {
			                validationSummary.append($m);
		                }
		            }

		        	validationSummary.show();
		}
		        });
		    }
		

		/**
		 * test if field is selectize input
		 * @param {any} el [jquery object - input element to test]
		 * @return boolean
		 */
	

		let firstnameInputs = _self.editForm.find('#edit-profile--first-name');
			firstnameInputs.attr({
				'data-parsley-pattern': '^[a-zA-Z]+$',
				'maxlength': '25'
			});

		let lastnameInputs = _self.editForm.find('#edit-profile--last-name');
			lastnameInputs.attr({
				'data-parsley-pattern': '^[a-zA-Z]+$',
				'maxlength': '40',
				'minlength': '2'
			});
        if(lastnameInputs.val.length+firstnameInputs.val.length)
		{
	    let $phoneInput:any   = _self.editForm.find('.phoneinput__phonenumber input');

		$phoneInput
			.on('focus', function(e:any){
				let $this:any = $(this);
				$this.editClass('input-focused').removeClass('has-error');
				$this.parent().editClass('input-focused');
				$phoneInput.editClass('input-filled').removeClass('has-error');
			})
		}
		
	}
	return isvalid
	}
	updateMemberIc(htmlFormData:any,addmyTravellerview:any){
		let _self = this;
		let bcommon = _self.bookingformcommon;
		//bcommon.preloader();
		$.ajax({
			type: 'POST',
			data: htmlFormData,
			url:'/bin/services/new/gtsAddUpdateTravellerDetails',
			success: function(msg:any) {
					   if(typeof msg==='string'){
						msg = JSON.parse(msg);
						}else{
							msg=msg;
						}
						let isSuccess: boolean = false;
						if (msg.hasOwnProperty('status')) {
							if (msg.status == "ISOK") {
								$(".user--claimed--msg").addClass("hideClass");
								$(".user--claimed--msg").removeClass("showClass");
								$(".user--submitted--msg").addClass("hideClass");
								$(".user--submitted--msg").removeClass("showClass");
								isSuccess = true;
							} 
							else if (msg.status == "NOTOK") {
								bcommon.preloaderClose();
								$(".user--claimed--msg").addClass("showClass");
								$(".user--claimed--msg").removeClass("hideClass");
								$(".user--submitted--msg").addClass("hideClass");
								$(".user--submitted--msg").removeClass("showClass");
								isSuccess = false;
							}
							else if (msg.status == "SUB") {
								bcommon.preloaderClose();
								$(".user--submitted--msg").addClass("showClass");
								$(".user--submitted--msg").removeClass("hideClass");
								$(".user--claimed--msg").addClass("hideClass");
								$(".user--claimed--msg").removeClass("showClass");
								isSuccess = false;
							}		
						}
						if (isSuccess) {
					   $(".mytravellererror_message").html("");
						let enableallothers_below=$(addmyTravellerview).nextAll();
						let enableallothers_above=$(addmyTravellerview).prevAll();
						let addmyTraveller=addmyTravellerview.children[1].id;
						$('#'+addmyTraveller).hide();
						let cancel_showtravell=addmyTravellerview.nextElementSibling.children[0].className;
						$("."+cancel_showtravell).show();
						let cancel_showtra=addmyTravellerview.nextElementSibling.children[0].children[3].id;
						$("#"+cancel_showtra).show();
						let cancel_showtrar=addmyTravellerview.nextElementSibling.children[0].children[4].id;
						$("#"+cancel_showtrar).hide();
						$(enableallothers_below).css({ 'opacity': '1','pointer-events': 'auto' });							
						$(enableallothers_above).css({ 'opacity': '1','pointer-events': 'auto' });
						if (($('#members-travel--stimulus').length) > 0) {
							$('.check-box--terms--cond--section').css({ 'pointer-events': 'auto' });
							$('.select--checkbox').css({'pointer-events': 'auto' });
							$('.btn-memberadd--submit').css({ 'pointer-events': 'auto' });		
							for(let i=0;i<9;i++)
							{
								if($('.firsttraveller_'+i+' .edittraveller-details').hasClass("data-offer"))
								{
									$('.firsttraveller_'+i+' .edittraveller-details').css({ 'pointer-events': 'none' });
								}
								else{
									$('.firsttraveller_'+i+' .edittraveller-details').css({ 'pointer-events': 'auto' });
								}
							}
						}	
						_self.travellmemberBase.populatedataa();					
						bcommon.preloaderClose();
					}

			}, 
			error: function(error:any) {
				$(".mytravellererror_message").html("Sorry, a general error occurred. Please try again later.");
				$('html, body').animate({ scrollTop: '100px' });
				bcommon.preloaderClose();
			},
					cache: false,
					contentType: false,
					processData: false,
		});
		
	}

	addtravellerform(): any {
		let _self = this;
		let _clickCount = 0;
		$('.btn-member--addsubmit').click((evt: any) => {	
		let editmy_showtraveller=evt.currentTarget.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.children[1].children[0].children[0].id;
		editmy_showtraveller = $('#'+editmy_showtraveller);
		let addmyTravellerview=evt.currentTarget.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;
		 $(window).unbind('scroll');
		 var isvalid=_self.validateForm(editmy_showtraveller,addmyTravellerview)
		if(_clickCount == 0 && isvalid==false) {
			_clickCount = 1;
			_self.validateForm(editmy_showtraveller,addmyTravellerview)
		}
	   
		 evt.preventDefault();
         evt.stopPropagation();
		});
}
	
}
let scope:Element = document.querySelector('#member-gov-stimulustraveler');

if (scope){
	try {
	let memberstraveller = new membertraveller();
		memberstraveller.initTextInputs();
		memberstraveller.initDatepickerInputs();
		memberstraveller.addtravellerform();	
	} catch(e) {console.error(e);}
}